module.exports = __webpack_public_path__ + "img/pepa.304d4dc0.jpg";